module.exports = __webpack_public_path__ + "static/primer-block-button-56a9be274b5af4a3b49546bfa8830c67.png";